export default __webpack_public_path__ + "static/media/mobile.116a806a.svg";